var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-model",on:{"click":_vm.close}},[_c('i',{staticClass:"pt-iconfont icon-guanbi"}),_c('img',{attrs:{"src":_vm.url,"alt":""},on:{"click":function($event){$event.stopPropagation();return (function (){})($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }